/* unplugin-vue-components disabled */import { render } from "./PopupContainer.vue?vue&type=template&id=df33c902&ts=true"
import script from "./PopupContainer.vue?vue&type=script&lang=ts"
export * from "./PopupContainer.vue?vue&type=script&lang=ts"

import "./PopupContainer.vue?vue&type=style&index=0&id=df33c902&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__